import React, { useState, useEffect } from "react";

import { connect } from "react-redux";

import axios from "axios";

import Header from "./Header/Header";

import PracticeList from "./PracticeList/PracticeList";

import SubjectTabs from "./SubjectTabs/SubjectTabs";

import { url_275 } from "../../../../../custom_utilities/api_services";

import Dropdown from "./Dropdown/Dropdown";

import useAuthUtils from "../../../../../hooks/auth/useAuthUtils";

import LoaderPopUp from "../../../../../components/loader/loader";

import "./Ncert.css";

import PersistentSidebarLayout from "../../../../../components/PersistentSidebarLayout/PersistentSidebarLayout";

const Ncert = ({ token, tokenType, loader }) => {
  const { startLoading, finishLoading } = useAuthUtils();

  const [ncertData, setNcertdata] = useState(null);

  const [currentSubject, setCurrentSubject] = useState(null);

  const [currentOption, setCurrentOption] = useState("");

  useEffect(() => {
    fetchNcertData();
  }, [currentOption]);

  useEffect(() => {
    if (ncertData) {
      setCurrentSubject(ncertData.subject_wise_chapters?.[0]?.sub_name || null);

      setCurrentOption(ncertData.class_id || "");
    }
  }, [ncertData]);

  const fetchNcertData = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    const apiUrl = `${url_275}?class_id=${currentOption}`;

    try {
      startLoading();

      const response = await axios.get(apiUrl, { headers });

      if (response.data.status == "success") {
        setNcertdata(response.data.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      finishLoading();
    }
  };

  const filteredData = ncertData?.subject_wise_chapters?.filter((item) => {
    return item.sub_name === currentSubject;
  });

  return (
    <PersistentSidebarLayout>
      <div className="ncert-wrapper">
        <Header />

        <div className="subjects-and-dropdown" id="ncert-dropdown-header">
          <SubjectTabs
            subjectTabs={ncertData?.subject_wise_chapters}
            setCurrentSubject={setCurrentSubject}
            currentSubject={currentSubject}
          />

          <Dropdown
            classOptions={ncertData?.class_options}
            currentOption={currentOption}
            setCurrentOption={setCurrentOption}
          />
        </div>

        <PracticeList chapters={filteredData} web_load_url="/ncert-test" />

        {loader && <LoaderPopUp />}
      </div>
    </PersistentSidebarLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,

    token: state.auth.authToken,

    tokenType: state.auth.tokenType,
  };
};

export default connect(mapStateToProps)(Ncert);
